@for (multiField of _multiFields; track multiField) {
  <div>
    <label>@if (multiField.Mandatory) {
      <span>* </span>
    }{{checkTranslation(multiField.Label)}}</label>
    @if (multiField.Type == 'string' || multiField.Type == 'numeric') {
      <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" [form]="form" [ngModel]="getProp(multiField.Binding)"
      (ngModelChange)="setProp(multiField.Binding, $event)" [isReadOnly]="getReadOnly()" name="multiField.Binding"></sem-text-box>
    }
    @if (multiField.Type == 'date') {
      <sem-date-picker [form]="form" [ngModel]="getProp(multiField.Binding)" (ngModelChange)="setProp(multiField.Binding, $event)"
      name="multiField.Binding" date-format="DD/MM/YYYY" [templateType]="'calendar_month'" [isReadOnly]="getReadOnly()"></sem-date-picker>
    }
    @if (multiField.Type == 'registry') {
      <sem-drop-down-select [minWidth]="minWidth" [form]="form" [filterField]="'Title'" [titleField]="'Title'" [parent]="guid"
        [galregistryname]="multiField.LinkedEntity" [ngModel]="getProp(multiField.Binding)"
        (ngModelChange)="setProp(multiField.Binding, $event)" [subBindingPropertyName]="''" [preLoad]="true"
        (itemSelected)="ddItemSelected($event)" [isReadOnly]="getReadOnly()" name="{{multiField.Binding}}" [type]="1" [multiFieldRootPropertyBinding]="''" [waitForFilteredValue]="false" [filteredValueBinding]="''">
      </sem-drop-down-select>
    }
    @if (multiField.Type == 'bool') {
      <sem-check-box [form]="form" [isReadOnly]="getReadOnly()" [ngModel]="getProp(multiField.Binding)"
        (ngModelChange)="setProp(multiField.Binding, $event)" name="{{multiField.Binding}}">
      </sem-check-box>
    }
  </div>
}